/**
 * Here goes the actionTypes
 */
export const REQUEST_PAYMENTREQUEST_ONGOING = 'REQUEST_PAYMENTREQUEST_ONGOING';
export const RECEIVE_PAYMENTREQUEST_ONGOING = 'RECEIVE_PAYMENTREQUEST_ONGOING';
export const FAILURE_PAYMENTREQUEST_ONGOING = 'FAILURE_PAYMENTREQUEST_ONGOING';



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/constants.js